var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg10(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "179.92mm",
    height: "130.02mm",
    viewBox: "0 0 179.92 130.02",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath7503"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.4305e-5 0h960v540h-960z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath7519"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m81 1.8311e-4h429.75v375h-429.75z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath7529"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath7573"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 540h960v-540l-960-6.1035e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath7583"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 540h960v-540l-960-6.1035e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath7593"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 540h960v-540h-960",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath7603"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 540h960v-540h-960",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath7621"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m375.02 201.48 21.56-54.92-71.8-28.19-21.56 54.93z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath7631"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath7647"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m153 319.5h72v72h-72z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath7657"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath7669"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m495 42h93.75v93.75h-93.75z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath7679"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath7691"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.5259e-5 540h960v-540h-960",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath7701"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.5259e-5 540h960v-540h-960",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath7711"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m384.75 135h49.5v49.5h-49.5z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath7721"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-575.28 -420.98)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.35278 0 0 -.35278 543.53 562.34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90 32.143h510v368.57h-510z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath7503)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1,0,0,-1,7.2,495.55)",
    fill: "#000000",
    fontFamily: "TimesNewRomanPSMT",
    fontSize: "36.05px"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 24.045349 39.799198 51.803848 67.59375 77.327248 88.610901 105.87885 117.8835 128.4101 146.4351 162.22501 171.99455 181.00705 196.79695 214.0649 223.83446 238.0742 249.32179 275.56619 292.83414 301.84665 310.85916 326.64905 338.65369 348.42325 365.69119 381.48111 397.992 409.23959 425.02951 437.03415 452.82404 462.55756 471.57004 488.83801 499.32855 515.11847 527.12311 536.17163 545.94122 554.95367 570.74359 587.21844 596.23096 608.9566 624.74652 642.01447 659.28241 677.30737 686.31989 696.08948 705.85901 723.88397 741.15198 753.87762 765.88226 786.14233",
    y: 0
  }, "Care for patients while they are in critical condition (S)"))), /*#__PURE__*/React.createElement("path", {
    d: "m131.63 184.12c0 19.89 16.45 36 36.75 36 20.29 0 36.75-16.11 36.75-36 0-19.88-16.46-36-36.75-36-20.3 0-36.75 16.12-36.75 36z",
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m131.63 184.12c0 19.89 16.45 36 36.75 36 20.29 0 36.75-16.11 36.75-36 0-19.88-16.46-36-36.75-36-20.3 0-36.75 16.12-36.75 36z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath7519)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.9687,0,-9.4e-8,5.9687,81,-54.75)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath7529)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.384 40.116c0 2.485-2.015 4.5-4.5 4.5s-4.5-2.015-4.5-4.5 2.015-4.5 4.5-4.5c2.484 3e-3 4.497 2.016 4.5 4.5zm-4.5-3c-1.657 0-3 1.343-3 3s1.343 3 3 3 3-1.343 3-3-1.343-3-3-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.384 26.616h24v-0.75c2e-3 -2.07 1.68-3.748 3.75-3.75h32.25v-3.75h1.5v21c-2e-3 2.07-1.68 3.748-3.75 3.75h-37.5c-4.14-5e-3 -7.495-3.36-7.5-7.5h-12.75v17.25c0 0.414-0.3358 0.75-0.75 0.75s-0.75-0.336-0.75-0.75v-34.5h1.5zm25.5 0v15h32.25c1.243 0 2.25-1.007 2.25-2.25v-15.75h-32.25c-1.243 0-2.25 1.007-2.25 2.25zm-5.25 15h3.75v-6h-9.75c4e-3 3.312 2.688 5.996 6 6zm-20.25-7.5h24v-6h-24z"
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "m160.88 193.5c0 7.66 5.87 13.87 13.12 13.87s13.13-6.21 13.13-13.87-5.88-13.88-13.13-13.88-13.12 6.22-13.12 13.88z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.88 193.5c0 7.66 5.87 13.87 13.12 13.87s13.13-6.21 13.13-13.87-5.88-13.88-13.13-13.88-13.12 6.22-13.12 13.88z",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168.38 202.87c0 7.46 5.87 13.5 13.12 13.5s13.13-6.04 13.13-13.5c0-7.45-5.88-13.5-13.13-13.5s-13.12 6.05-13.12 13.5z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168.38 202.87c0 7.46 5.87 13.5 13.12 13.5s13.13-6.04 13.13-13.5c0-7.45-5.88-13.5-13.13-13.5s-13.12 6.05-13.12 13.5z",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m190.57 207.83c0-1.07-0.87-1.94-1.95-1.94s-1.95 0.87-1.95 1.94c0 1.08 0.87 1.95 1.95 1.95s1.95-0.87 1.95-1.95z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m180.53 192.58c0-1.07-0.87-1.95-1.94-1.95-1.08 0-1.95 0.88-1.95 1.95 0 1.08 0.87 1.95 1.95 1.95 1.07 0 1.94-0.87 1.94-1.95z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m234.38 240.75c0 27.96 22.49 50.62 50.25 50.62 27.75 0 50.25-22.66 50.25-50.62s-22.5-50.63-50.25-50.63c-27.76 0-50.25 22.67-50.25 50.63z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m234.38 240.75c0 27.96 22.49 50.62 50.25 50.62 27.75 0 50.25-22.66 50.25-50.62s-22.5-50.63-50.25-50.63c-27.76 0-50.25 22.67-50.25 50.63z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.13 257.25c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.13 257.25c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m279.38 257.25c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m279.38 257.25c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m276.12 254.97c0-1.07-0.87-1.94-1.95-1.94s-1.95 0.87-1.95 1.94c0 1.08 0.87 1.95 1.95 1.95s1.95-0.87 1.95-1.95z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m295.05 255.17c0-1.07-0.87-1.95-1.95-1.95-1.07 0-1.94 0.88-1.94 1.95 0 1.08 0.87 1.95 1.94 1.95 1.08 0 1.95-0.87 1.95-1.95z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m259.13 283.12 25.5 49.5 25.5-49.5z",
    fill: "#4472c4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m259.13 283.12 25.5 49.5 25.5-49.5z",
    fill: "none",
    stroke: "#2f528f",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath7573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m334.94 230.72 5.85-18.65c3.23-10.3 1.31-20.08-4.31-21.84-5.61-1.76-12.78 5.16-16.01 15.46l-5.86 18.65z",
    fill: "#000000",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath7583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m334.94 230.72 5.85-18.65c3.23-10.3 1.31-20.08-4.31-21.84-5.61-1.76-12.78 5.16-16.01 15.46l-5.86 18.65z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath7593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m259.36 223.16-10.32-16.61c-5.7-9.17-14.37-14.08-19.37-10.98-5 3.11-4.43 13.06 1.27 22.23l10.32 16.6z",
    fill: "#000000",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath7603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m259.36 223.16-10.32-16.61c-5.7-9.17-14.37-14.08-19.37-10.98-5 3.11-4.43 13.06 1.27 22.23l10.32 16.6z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m294.51 254.24c0-1.08-0.87-1.95-1.94-1.95-1.08 0-1.95 0.87-1.95 1.95 0 1.07 0.87 1.95 1.95 1.95 1.07 0 1.94-0.88 1.94-1.95z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m280.89 255.87h-10.8c-1.08 0-1.95-0.87-1.95-1.95 0-1.07 0.87-1.95 1.95-1.95h2.69c0.25 0 0.49 0.05 0.72 0.14l0.43 0.17-0.66-0.14 0.82 0.03c0.25 0.01 0.49 0.07 0.72 0.16l0.45 0.2-0.27-0.09 0.63 0.17-0.24-0.05 0.39 0.06c0.37 0.05 0.72 0.2 1 0.45l0.39 0.34-0.97-0.45 0.37 0.06c0.54 0.08 1.02 0.39 1.33 0.84l0.22 0.34-0.14-0.19 0.17 0.2c0.3 0.36 0.47 0.81 0.47 1.27v2.3l-0.39-1.17 0.17 0.22-0.29-0.31 0.2 0.17-1.27-0.47h2.52l-0.38 0.04 1.13-0.22-0.07 0.01 0.93-0.22h-0.02l1.1-0.28-0.27 0.09 0.88-0.37c0.2-0.08 0.41-0.13 0.63-0.15l0.88-0.05-0.3 0.04 0.87-0.2c0.15-0.03 0.29-0.05 0.43-0.05h0.88l-0.43 0.05 0.88-0.2 0.35-0.04 0.65-0.03-0.53 0.1 0.59-0.2c0.2-0.07 0.41-0.1 0.62-0.1h14.65l-1.62 0.87 0.12-0.17c0.52-0.8 1.55-1.09 2.42-0.7 0.86 0.39 1.32 1.35 1.08 2.27s-1.11 1.53-2.06 1.45l-0.31-0.03c-0.88-0.08-1.6-0.75-1.75-1.62l-0.05-0.34 1.76 1.62-0.34-0.03c-0.64-0.05-1.2-0.41-1.52-0.96l-0.2-0.34 0.4 0.49-0.23-0.2 0.3 0.22-0.34-0.2c-0.26-0.15-0.47-0.36-0.64-0.61l-0.23-0.34 1.48 0.87-0.37-0.03c-0.23-0.02-0.46-0.08-0.67-0.18l-0.37-0.17c-0.16-0.07-0.31-0.17-0.45-0.29l-0.2-0.17 1.11 0.47-0.34-0.03c-0.41-0.04-0.8-0.2-1.11-0.46l-0.2-0.17 0.57 0.34-0.37-0.15 0.41 0.11-0.37-0.06-0.36-0.09-0.4-0.14c-0.27-0.1-0.52-0.25-0.72-0.46l-0.2-0.19 1.23 0.56-0.37-0.03c-0.37-0.03-0.72-0.16-1.02-0.38l-0.22-0.17 1.16 0.39h-0.76c-0.47 0-0.92-0.17-1.27-0.47l-0.2-0.17 0.95 0.44-0.34-0.05c-0.35-0.06-0.68-0.22-0.95-0.45l-0.2-0.17 1.27 0.47h-1.84c-1.08 0-1.95-0.87-1.95-1.95 0-1.07 0.87-1.95 1.95-1.95h1.84c0.47 0 0.92 0.17 1.27 0.47l0.2 0.17-0.95-0.44 0.34 0.06c0.35 0.06 0.68 0.21 0.95 0.44l0.2 0.17-1.27-0.47h0.76c0.43 0 0.84 0.14 1.17 0.39l0.23 0.17-1.02-0.38 0.37 0.03c0.46 0.03 0.9 0.23 1.23 0.56l0.2 0.2-0.73-0.46 0.4 0.14-0.36-0.09 0.37 0.06c0.14 0.02 0.27 0.06 0.4 0.11l0.37 0.14c0.21 0.08 0.4 0.19 0.57 0.34l0.2 0.17-1.11-0.47 0.34 0.03c0.41 0.04 0.8 0.2 1.11 0.47l0.2 0.17-0.45-0.29 0.36 0.17-0.66-0.18 0.37 0.03c0.59 0.05 1.14 0.36 1.47 0.86l0.22 0.34-0.64-0.6 0.35 0.2 0.3 0.22 0.22 0.19c0.16 0.14 0.3 0.31 0.4 0.49l0.2 0.34-1.52-0.96 0.34 0.03c0.89 0.07 1.61 0.74 1.76 1.62l0.06 0.34-1.75-1.62 0.31 0.03c0.69 0.06 1.29 0.48 1.59 1.1 0.29 0.62 0.24 1.35-0.14 1.92l-0.11 0.17c-0.37 0.54-0.97 0.87-1.63 0.87h-14.65l0.61-0.1-0.59 0.2c-0.17 0.05-0.35 0.09-0.53 0.09l-0.65 0.03 0.34-0.04-0.88 0.19c-0.14 0.04-0.28 0.05-0.43 0.05h-0.88l0.43-0.05-0.88 0.2-0.3 0.05-0.88 0.05 0.63-0.14-0.88 0.36-0.27 0.09-1.1 0.29h-0.03l-0.93 0.23-0.08 0.02-1.14 0.22-0.38 0.04h-2.52c-0.47 0-0.92-0.16-1.27-0.47l-0.2-0.17c-0.1-0.09-0.2-0.19-0.29-0.31l-0.17-0.22c-0.25-0.34-0.39-0.75-0.39-1.17v-2.3l0.47 1.27-0.17-0.2-0.14-0.19-0.23-0.34 1.33 0.85-0.37-0.06c-0.36-0.05-0.7-0.21-0.97-0.44l-0.4-0.35 0.99 0.45-0.39-0.05-0.24-0.05-0.62-0.17-0.27-0.1-0.46-0.19 0.72 0.16-0.82-0.03c-0.23-0.01-0.45-0.06-0.66-0.14l-0.43-0.17 0.73 0.14h-2.69c-1.08 0-1.95-0.87-1.95-1.95 0-1.07 0.87-1.95 1.95-1.95h10.8c1.07 0 1.94 0.88 1.94 1.95 0 1.08-0.87 1.95-1.94 1.95z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m270.9 247.72c0-1.08-0.87-1.95-1.95-1.95-1.07 0-1.95 0.87-1.95 1.95 0 1.07 0.88 1.95 1.95 1.95 1.08 0 1.95-0.88 1.95-1.95z",
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m293.38 247.72c0-1.08-0.87-1.95-1.95-1.95-1.07 0-1.95 0.87-1.95 1.95 0 1.07 0.88 1.95 1.95 1.95 1.08 0 1.95-0.88 1.95-1.95z",
    fill: "#000000",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath7621)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.99721 .39145 -.29946 .76285 324.78 118.37)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath7631)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m61.134 44.616c5e-3 4.142-3.349 7.504-7.491 7.509s-7.504-3.349-7.509-7.491c-4e-3 -3.711 2.706-6.868 6.375-7.424v-18.094c0-6.835-5.54-12.375-12.375-12.375s-12.375 5.54-12.375 12.375v9.432c7.196 0.59 12.739 6.597 12.75 13.818-1e-3 0.319-0.137 0.622-0.375 0.833v20.167c-2e-3 2.07-1.68 3.747-3.75 3.75h-0.497v0.14c-0.181 0.576-0.709 0.972-1.312 0.985h-0.469c-1.035 0-1.875-0.839-1.875-1.875s0.84-1.875 1.875-1.875h0.469c0.559 0.02 1.063 0.343 1.312 0.844v0.281h0.497c1.243 0 2.25-1.007 2.25-2.25v-20.167c-0.238-0.212-0.374-0.515-0.375-0.833 0-6.42-5.205-11.625-11.625-11.625s-11.625 5.205-11.625 11.625c-1e-3 0.319-0.137 0.622-0.375 0.833v20.167c0 1.243 1.007 2.25 2.25 2.25h0.497v-0.281c0.224-0.523 0.744-0.857 1.313-0.844h0.468c1.036 0 1.875 0.839 1.875 1.875s-0.839 1.875-1.875 1.875h-0.468c-0.604-0.013-1.132-0.409-1.313-0.985v-0.14h-0.497c-2.07-3e-3 -3.748-1.68-3.75-3.75v-20.167c-0.238-0.212-0.374-0.515-0.375-0.833 0.011-7.22 5.554-13.228 12.75-13.818v-9.432c0-8.077 6.548-14.625 14.625-14.625s14.625 6.548 14.625 14.625v18.094c3.661 0.557 6.368 3.702 6.375 7.406zm-7.16-5.983c-0.22 0.077-0.459 0.077-0.679 0-3.308 0.188-5.838 3.022-5.651 6.33s3.021 5.838 6.33 5.651c3.308-0.187 5.838-3.021 5.651-6.33-0.173-3.046-2.605-5.478-5.651-5.651z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.634 48.741c-2.278 0-4.125-1.847-4.125-4.125s1.847-4.125 4.125-4.125 4.125 1.847 4.125 4.125c-2e-3 2.277-1.848 4.123-4.125 4.125zm0-6.75c-1.45 0-2.625 1.175-2.625 2.625s1.175 2.625 2.625 2.625 2.625-1.175 2.625-2.625-1.175-2.625-2.625-2.625z"
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "m295.88 223.5c0-5.59-7.22-10.13-16.13-10.13s-16.12 4.54-16.12 10.13h5.06c0-2.8 4.95-5.06 11.06-5.06s11.06 2.26 11.06 5.06z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m295.88 223.5c0-5.59-7.22-10.13-16.13-10.13s-16.12 4.54-16.12 10.13h5.06c0-2.8 4.95-5.06 11.06-5.06s11.06 2.26 11.06 5.06z",
    fill: "none",
    stroke: "#a5a5a5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath7647)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(153,319.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath7657)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m36.384 63.366c14.912 0 27-12.088 27-27s-12.088-27-27-27-27 12.088-27 27c0.0169 14.905 12.095 26.983 27 27m0 1.5c-15.74 0-28.5-12.76-28.5-28.5s12.76-28.5 28.5-28.5 28.5 12.76 28.5 28.5c7e-3 15.733-12.741 28.493-28.475 28.5h-0.025z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.884 52.866v-12h12v-9h-12v-12h-9v12h-12v9h12v12zm-10.5 1.5v-12h-12v-12h12v-12h12v12h12v12h-12v12z"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath7669)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3021,0,-7.54e-7,1.3021,495,42)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath7679)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m63.384 53.628h-17.25v4.488c-2e-3 2.07-1.68 3.748-3.75 3.75h-12c-2.07-2e-3 -3.748-1.68-3.75-3.75v-4.488h-17.25c-1.6546-5e-3 -2.9946-1.345-3-3v-36.012c0.0054-1.655 1.3454-2.995 3-3h54c1.655 5e-3 2.995 1.345 3 3v36.011c-5e-3 1.655-1.345 2.996-3 3.001zm-35.25 4.488c0 1.243 1.007 2.25 2.25 2.25h12c1.243 0 2.25-1.007 2.25-2.25v-4.483h-16.5zm36.75-43.5c0-0.828-0.672-1.5-1.5-1.5h-54c-0.8285 0-1.5 0.672-1.5 1.5v36.011c0 0.829 0.6715 1.5 1.5 1.5h54c0.828 0 1.5-0.671 1.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.932 21.366h-7.099v5.107l-4.425-2.529-3.55 6.15 4.413 2.522-4.412 2.521 3.544 6.202 4.43-2.531v5.058h7.099v-5.107l4.425 2.529 3.55-6.15-4.413-2.522 4.411-2.521-3.543-6.202-4.43 2.531zm-5.599 1.5h4.099v6.142l5.372-3.067 2.055 3.6-5.388 3.075 5.385 3.075-2.047 3.554-5.374-3.07v6.191h-4.102v-6.143l-5.374 3.068-2.057-3.6 5.392-3.075-5.386-3.075 2.051-3.554 5.374 3.07z"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath7691)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m184.1 177.02c-1.62 3.25 1.41 8.03 6.75 10.69 5.34 2.65 10.98 2.16 12.59-1.09l-2.94-1.46c-0.81 1.62-4.47 1.45-8.19-0.4-3.72-1.84-6.07-4.66-5.27-6.28z",
    fill: "#ffffff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath7701)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m184.1 177.02c-1.62 3.25 1.41 8.03 6.75 10.69 5.34 2.65 10.98 2.16 12.59-1.09l-2.94-1.46c-0.81 1.62-4.47 1.45-8.19-0.4-3.72-1.84-6.07-4.66-5.27-6.28z",
    fill: "none",
    stroke: "#a5a5a5",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath7711)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6875 -1.88e-7 -3.77e-7 .6875 384.75 135)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath7721)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.384 13.866c-1.243 0-2.25 1.007-2.25 2.25v33.75c0 1.243 1.007 2.25 2.25 2.25h2.625c0.607-0.014 1.111 0.467 1.125 1.075v0.05 3.375h19.5v-3.375c-0.014-0.608 0.467-1.111 1.075-1.125h0.05 2.625c1.243 0 2.25-1.007 2.25-2.25v-5.993h-24c-0.828 0-1.5-0.671-1.5-1.5v-13.5c0-0.828 0.672-1.5 1.5-1.5h24v-6.744h1.5v29.237c-2e-3 2.07-1.68 3.748-3.75 3.75h-2.25v3h1.5c0.801-0.028 1.472 0.599 1.5 1.399 1e-3 0.034 1e-3 0.067 0 0.101v4.5c-2e-3 2.07-1.68 3.747-3.75 3.75h-21c-2.07-3e-3 -3.748-1.68-3.75-3.75v-4.5c-0.028-0.801 0.599-1.472 1.399-1.5 0.034-1e-3 0.067-1e-3 0.101 0h1.5v-3h-2.25c-2.07-2e-3 -3.748-1.68-3.75-3.75v-33.75c2e-3 -2.07 1.68-3.748 3.75-3.75h13.519c-6e-3 0.131-0.02 0.261-0.02 0.394 3e-3 0.37 0.032 0.74 0.087 1.106zm5.25 15.013v13.5h24v-13.5zm-4.5 29.237v4.5c0 1.243 1.007 2.25 2.25 2.25h21c1.243 0 2.25-1.007 2.25-2.25v-4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.462 18.366h-12.657c-3.106 0-5.625-2.518-5.625-5.625 0-3.1066 2.519-5.625 5.625-5.625h12.657c3.107 0 5.625 2.5184 5.625 5.625 0 3.107-2.518 5.625-5.625 5.625zm-16.782-5.625c3e-3 2.277 1.848 4.122 4.125 4.125h5.625v-8.25h-5.625c-2.277 0.0033-4.122 1.848-4.125 4.125zm16.782-4.125h-5.532v8.25h5.532c2.279 0 4.125-1.847 4.125-4.125s-1.846-4.125-4.125-4.125z"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg10);
export default __webpack_public_path__ + "static/media/10.36176d2d6f8375f04a540f3eaab5ac6f.svg";
export { ForwardRef as ReactComponent };